module.exports = __webpack_public_path__ + "static/media/star.501e0fe3.svg";